'use client';

export default function ThreeButtonsTopBar({
  leftButton,
  centerTitle,
  rightButton,
  topBarClassName = '',
}: {
  leftButton: React.ReactNode;
  centerTitle: React.ReactNode;
  rightButton: React.ReactNode;
  topBarClassName?: string;
}) {
  return (
    <div
      className={`w-full max-w-480pxr h-56pxr fixed z-20 top-0 bg-white py-16pxr px-24pxr flex items-center justify-between ${topBarClassName}`}
    >
      {leftButton}
      {centerTitle}
      {rightButton}
    </div>
  );
}
